import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.adjust()
  }

  adjust() {
    this.element.style.height = 'auto'
    this.element.style.height = `${this.element.scrollHeight}px`
  }

  input() {
    this.element.value = this.element.value.replace(/[\r\n]+/g, ' ')
    this.adjust()
  }

  keydown(event) {
    if (event.key === "Enter") event.preventDefault()
  }
}
